import { useEffect, useState } from "react";
import { Marker, Popup, useMapEvents } from "react-leaflet";

const AddMarker = (props) => {
  const [coord, setPosition] = useState([]);

  const removeMarker = (pos) => {
    setPosition((prevCoord) =>
      prevCoord.filter((coord) => JSON.stringify(coord) !== JSON.stringify(pos))
    );
  };

  const handleResponse = (latlng) => {
    // Insère les coordonnées dans la réponse
    let newResult = props.result;
    newResult["position"] = latlng;
    props.setResult(newResult);
    // Autorise à poursuivre le formulaire
    // props.setAuthorization(true);
  };
  useMapEvents({
    click: (e) => {
      handleResponse(e.latlng);
      setPosition([...coord, e.latlng]);
    },
  });

  useEffect(() => {
    if (coord[1]) {
      removeMarker(coord[0]);
    }
    if (coord[2]) {
      removeMarker(coord[1]);
      removeMarker(coord[0]);
    }
  }, [coord]);

  if (props.result.posicursor === "OK") {
    return (
      <div>
        {coord.map((pos, idx) => (
          <Marker
            key={`marker-${idx}`}
            position={pos}
            draggable={true}
            eventHandlers={{
              click: (e) => {
                //console.log(e.latlng);
              },
            }}
          >
            <Popup>
              <button onClick={() => removeMarker(coord[0])}>
                Supprimer le curseur
              </button>
            </Popup>
          </Marker>
        ))}
      </div>
    );
  } else {
    return "";
  }
};
export default AddMarker;
